import { useMemo, useState } from 'react';

import cn from 'classnames';
import { equals, isEmpty, isNil } from 'ramda';
import { useSelector } from 'react-redux';

import { HeaderDropDownContainer } from 'components/Header/partials';
import MarginModeSelection from 'components/primaryHeader/partials/MarginModeSelection';
import HaltedLabel from 'components/productHeader/HaltedLabel';
import SelectedProducLastPrice from 'components/productHeader/lastPrice';
import Render from 'components/render';
import StickyHeadersPortal from 'components/StickyHeadersPortal';
import StraddleIntro from 'components/StraddleIntro';
import { isOptions } from 'helpers/utils';
import { APP_DRAWER_TAB_ID_MAPPING } from 'reducers/initialstate/appDrawer';
import { appDrawerSelector, showOrderOnChartSelector } from 'selectors/otherSelectors';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import { ContractType } from 'types/IProducts';

import styles from './index.module.scss';
import Mobile24hrHeader from './mobile24hrheader';
import MobileGreeks from './mobileGreeksArea';
import MobileProductDetails from './mobileProductDetails';

const MobileProductHeader = () => {
  const selectedProduct = useSelector(state => selectedProductSelector(state));
  const [showFullHeader, setShowFullHeader] = useState(false);
  const { activeTab } = useSelector(appDrawerSelector);
  const showOnChartScreen = useSelector(showOrderOnChartSelector);

  const isOperational =
    selectedProduct && equals(selectedProduct.trading_status, 'operational');
  const showGreeks = selectedProduct && isOptions(selectedProduct.contract_type);

  const shouldShow24hrHeader = useMemo(() => {
    if (isOperational && !isNil(selectedProduct) && !isEmpty(selectedProduct)) {
      if (activeTab === APP_DRAWER_TAB_ID_MAPPING.CHART_ORDERBOOK && showOnChartScreen) {
        return false;
      }
      return true;
    }
    return false;
  }, [activeTab, showOnChartScreen, isOperational, selectedProduct]);

  return (
    //  <TvReadyWrapper>
    //  {isTradingViewReady => isTradingViewReady ? (
    // ) : null}
    // </TvReadyWrapper>
    (<StickyHeadersPortal>
      <MarginModeSelection showFullHeader={showFullHeader} />
      <div
        className={cn(styles['mobile-product-header'], {
          [styles.showFullHeader]: showFullHeader,
        })}
        id="mobile-product-header"
      >
        <div id="header-dropdown" className={styles['dropdown-lastprice-section']}>
          <div className={styles['dropdown-area']}>
            <Render when={!isNil(selectedProduct) && !isEmpty(selectedProduct)}>
              <HeaderDropDownContainer
                showFullHeader={showFullHeader}
                expandProductDetails={setShowFullHeader}
              />
            </Render>
          </div>
          <div className={styles['lastprice-area']}>
            <Render when={!isNil(selectedProduct) && !isEmpty(selectedProduct)}>
              <SelectedProducLastPrice contractType={selectedProduct?.contract_type} />
            </Render>
          </div>
        </div>

        <Render
          when={!isOperational && !isNil(selectedProduct) && !isEmpty(selectedProduct)}
        >
          <HaltedLabel selectedProduct={selectedProduct} />
        </Render>

        <Render
          when={
            selectedProduct?.contract_type === ContractType.MoveOptions && showFullHeader
          }
        >
          <div className={styles.introContainer}>
            <StraddleIntro />
          </div>
        </Render>

        <Render when={shouldShow24hrHeader}>
          <Mobile24hrHeader
            selectedProduct={selectedProduct}
            showFullHeader={showFullHeader}
            setShowFullHeader={setShowFullHeader}
          />
        </Render>

        <Render
          when={
            !isNil(selectedProduct) &&
            !isEmpty(selectedProduct) &&
            showGreeks &&
            showFullHeader
          }
        >
          <MobileGreeks selectedProduct={selectedProduct} />
        </Render>

        <Render
          when={!isNil(selectedProduct) && !isEmpty(selectedProduct) && showFullHeader}
        >
          <MobileProductDetails selectedProduct={selectedProduct} />
        </Render>

        {/* {!isNil(selectedProduct) && !isEmpty(selectedProduct) && (
        <SelectedProducLastPrice />
      )}

      {isOperational ? (
        <>
          <div className={styles.divider}></div>
          <div id="header-placeholder" className={styles['ticker-header']}>
            {!isNil(selectedProduct) && !isEmpty(selectedProduct) && (
              <Desktop24hrHeader selectedProduct={selectedProduct} />
            )}
          </div>
        </>
      ) : (
        !isNil(selectedProduct) &&
        !isEmpty(selectedProduct) && (
          <HaltedLabel selectedProduct={selectedProduct} />
        )
      )} */}
      </div>
    </StickyHeadersPortal>)
  );
};

export default MobileProductHeader;
